import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { Row } from "@/styles/utils/StyledGrid";
import { getBreakpointMinWidth } from "@/styles/utils/Utils";
import { breakpoints, colors, transitionDefault } from "@/styles/utils/vars";
import { ButtonBase, ButtonSliderArrow, cssButtonFastBuy } from "@/ui/Button/StyledButton";
import { StyledEntityImage } from "@/ui/EntityImage/Styled";
import { cssIcon, getSizeSVG } from "@/ui/Icon";
import { cssRadioGroup, RadioLabel, StyledRadio } from "@/ui/Radio/StyledRadio";
import { getTypographyBase, Heading1, Heading3, Paragraph12 } from "@/ui/Typography/Typography";
import { StyledList, StyledListItem } from "../../List/StyledList";
import { cssButtonIsActive } from "../../Paginator/StyledPaginator";
import { CounterInput, StyledAddToCartControl, StyledCounter, StyledPrice, StyledStoresAvailable } from "../parts";
import { StyledProductsSlider } from "../Slider";
import { ControlsButtonsContainer } from "../StyledProduct";
import { Side } from "../StyledProductPage";
const PADDING_CARD_CONTAINER_PC = 56;
const PADDING_CARD_CONTAINER_MOB = 18;
export const cssName = "cssName_c1t2bcwc";
export const StyledTable = /*#__PURE__*/styled('div')({
  name: "StyledTable",
  class: "StyledTable_sjq9z1p"
});
export const TableTitle = /*#__PURE__*/styled(Heading3)({
  name: "TableTitle",
  class: "TableTitle_t11kh5qp"
});
export const StyledTableContainer = /*#__PURE__*/styled('section')({
  name: "StyledTableContainer",
  class: "StyledTableContainer_siz8n3z"
});
export const TableCell = /*#__PURE__*/styled('div')({
  name: "TableCell",
  class: "TableCell_t1ue5gzr"
});
export const cssTableRowClickable = "cssTableRowClickable_c1xludr2";
export const TableRow = /*#__PURE__*/styled('div')({
  name: "TableRow",
  class: "TableRow_tpl2u3z"
});
export const StyledDetail = /*#__PURE__*/styled('section')({
  name: "StyledDetail",
  class: "StyledDetail_sbas5eq"
});
export const StyledDetailProduct = /*#__PURE__*/styled('section')({
  name: "StyledDetailProduct",
  class: "StyledDetailProduct_s19mbp9b"
});
export const Title = /*#__PURE__*/styled('div')({
  name: "Title",
  class: "Title_tycptok"
});
export const Description = /*#__PURE__*/styled(Paragraph12)({
  name: "Description",
  class: "Description_dk10rqi"
});
export const DescriptionProductWrapper = /*#__PURE__*/styled('div')({
  name: "DescriptionProductWrapper",
  class: "DescriptionProductWrapper_dsiy47g"
});
export const cssDescHidden = "cssDescHidden_c1hb14r7";
export const DescProduct = /*#__PURE__*/styled('div')({
  name: "DescProduct",
  class: "DescProduct_d1ylpk19"
});
export const DescProductInner = /*#__PURE__*/styled('div')({
  name: "DescProductInner",
  class: "DescProductInner_d14cmq48"
});
export const DescProductContainer = /*#__PURE__*/styled('div')({
  name: "DescProductContainer",
  class: "DescProductContainer_d1ow2c2o"
});
export const Gallery = /*#__PURE__*/styled('div')({
  name: "Gallery",
  class: "Gallery_g1aacy2d"
});
export const Info = /*#__PURE__*/styled('div')({
  name: "Info",
  class: "Info_iu0dqi6"
});
export const StyledMedia = /*#__PURE__*/styled('div')({
  name: "StyledMedia",
  class: "StyledMedia_s784hql"
});
export const Body = /*#__PURE__*/styled('div')({
  name: "Body",
  class: "Body_b1kihly3"
});
export const Footer = /*#__PURE__*/styled('footer')({
  name: "Footer",
  class: "Footer_f9fo09m"
});
export const Header = /*#__PURE__*/styled('header')({
  name: "Header",
  class: "Header_hs5wis2"
});
export const Card = /*#__PURE__*/styled('article')({
  name: "Card",
  class: "Card_cgyz3b4"
});

require("./StyledDetail.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledDetail.tsx");